import React from 'react';
import isEmpty from 'lodash/isEmpty';
import isNull from 'lodash/isNull'
import isUndefined from 'lodash/isUndefined'
import moment from 'moment'
import numeral from 'numeral'
import { makeJSDateObject, convertMSToObject } from './Utils';
import isNil from 'lodash/isNil';
import { isString } from 'lodash';

export const locale = moment.locale('es');

export const DATE_SHORT_FORMAT = 'DD-MMM-YYYY';
export const DATE_LONG_FORMAT = 'DD-MMM-YYYY HH:mm';
export const DATE_LONG_FORMAT_FULL = 'dddd, D [de] MMMM YYYY h:mm a';
export const DATE_VENCIMIENTO_TC_FORMAT = 'MM-YY';
export const TIME_SHORT_FORMAT = 'HH:mm';
export const TIME_LONG_FORMAT = 'HH:mm:ss';
export const TIME_SHORT_FORMAT_AM_PM = 'h:mm a';

export const GRUPOS_SANGUINEOS = [{ value: 'OP', text: 'O+' },
{ value: 'ON', text: 'O-' },
{ value: 'AP', text: 'A+' },
{ value: 'AN', text: 'A-' },
{ value: 'BP', text: 'B+' },
{ value: 'BN', text: 'B-' },
{ value: 'ABP', text: 'AB+' },
{ value: 'ABN', text: 'AB-' }];

export const DAYS = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
export const DAYS_SHORT = ['Dom.', 'Lun.', 'Mar.', 'Mié.', 'Jue.', 'Vie.', 'Sáb.'];

//Funciones especificas para objetos JSON

export function formatNombreCompleto(record) {
    return record.apellido2 ? `${record.apellido1} ${record.apellido2}, ${record.nombre}` : `${record.apellido1}, ${record.nombre}`;
}

//Funciones genéricas para formatear

export function renderDuration(miliseconds) {
    const data = convertMSToObject(miliseconds);
    if (data.hour > 0 && data.minute > 0) {
        return `${data.hour}h, ${data.minute}m`
    } else if (data.hour <= 0 && data.minute > 0) {
        return `${data.minute}m`
    } else if (data.hour > 0 && data.minute <= 0) {
        return `${data.hour}h`
    } else {
        return "N/A";
    }
}

export function formatWeekDesdeHasta(desde, hasta, full = false) {
    let _desde = moment(makeJSDateObject(desde));
    let _hasta = moment(makeJSDateObject(hasta));
    let formatDesde = "[del] ddd D", formatHasta = full ? "ddd D [de] MMMM, YYYY" : "D [de] MMM YYYY";
    if (!_desde.isSame(_hasta, 'month')) {
        formatDesde = full ? "[del] ddd D [de] MMMM" : "[del] D [de] MMM"
    }
    if (!_desde.isSame(_hasta, 'year')) {
        formatDesde = full ? "[del] ddd D [de] MMMM, YYYY" : "[del] D [de] MMM YYYY"
    }
    return _desde.format(formatDesde) + " al " + _hasta.format(formatHasta);
}

export function formatFechaCalendario(inicio, fin, { todoDia = false, month = '[de] MMMM', breakTime = false } = {}) {
    let _inicio = moment(makeJSDateObject(inicio));
    let _fin = moment(makeJSDateObject(fin));
    let _yearFormat = _inicio.isSame(_fin, 'year') && _inicio.isSame(Date.now(), 'year') && _fin.isSame(Date.now(), 'year') ? '' : ', YYYY';

    if (_inicio.isSame(_fin, 'day')) {
        if (_inicio.format('a') === _fin.format('a')) {
            if (breakTime) {
                return (<> {_inicio.format(`dddd, D ${month}${_yearFormat}`)}<br /> {_inicio.format(`h:mm`) + ' - ' + _fin.format('h:mm a')}</>);
            }
            return _inicio.format(`dddd, D ${month}${_yearFormat} - h:mm`) + ' - ' + _fin.format('h:mm a');
        } else if (todoDia)
            return _inicio.format(`dddd, D ${month}${_yearFormat}`) + ' - todo el día';
        else {
            if (breakTime) {
                return (<> {_inicio.format(`dddd, D ${month}${_yearFormat}`)}<br /> {_inicio.format(`h:mm a`) + ' - ' + _fin.format('h:mm a')}</>);
            }
            return _inicio.format(`dddd, D ${month}${_yearFormat} - h:mm a`) + ' - ' + _fin.format('h:mm a');
        }
    } else {
        return _inicio.format(`D ${month}${_yearFormat} - h:mm a`) + ' - ' + _fin.format(`D ${month}${_yearFormat}- h:mm a`);
    }
}

export function formatHoraCalendario(inicio, fin) {
    let _inicio = moment(makeJSDateObject(inicio));
    let _fin = moment(makeJSDateObject(fin));

    if (_inicio.isSame(_fin, 'day')) {
        if (_inicio.format('a') === _fin.format('a'))
            return _inicio.format('h:mm') + ' - ' + _fin.format('h:mm a');
        else
            return _inicio.format('h:mm a') + ' - ' + _fin.format('h:mm a');
    } else {
        return _inicio.format('D [de] MMMM, YYYY - h:mm a') + ' - ' + _fin.format('D [de] MMMM, YYYY- h:mm a');
    }
}

export const formatMonthYear = fechaValue => {
    const fecha = moment(makeJSDateObject(fechaValue));
    if (fecha.year() === moment().year()) {
        return fecha.format('MMMM')
    } else {
        return fecha.format('MMM YYYY')
    }
}

export const formatDateInYear = (fechaValue, formatDate = 'MMMM D', formatTime = ' [a las] h:mm a', yearFormat = ', YYYY') => {
    const fecha = moment(makeJSDateObject(fechaValue));
    const _yearFormat = fecha.year() === moment().year() ? '' : yearFormat;
    const _format = `${formatDate}${_yearFormat}${formatTime}`
    return fecha.format(_format)
}

export function toDate(string, format) {
    let fmt = format || DATE_SHORT_FORMAT;
    return moment(string, fmt).toDate();
}

export function formatCurrency(value, options = { decimal: true }) {
    const formatStr = options && options.decimal === true ? '$0,0.00' : '$0,0'
    return formatNumber(value, formatStr);
}

export function formatPercentage(value, options = { decimal: true }) {
    const formatStr = options && options.decimal === true ? '0.00%' : '0%'
    return formatNumber(value, formatStr);
}

export function formatNumber(value, template) {
    if (isNil(value)) {
        return value;
    }
    return numeral(value).format(template);
}

export function formatDate(date, format = DATE_LONG_FORMAT) {
    var d = date;
    if (!date) {
        return "";
    }
    if (typeof date === 'number') {
        d = new Date(date);
    }
    return moment(d).format(format);
}

export function formatTime(date, format = DATE_LONG_FORMAT) {
    return formatDate(date, TIME_LONG_FORMAT);
}

export function formatFechaForDisplay(isoDate) {
    return isoDate ? moment(makeJSDateObject(isoDate)).format(DATE_SHORT_FORMAT) : "";
}

export function formatFechaHoraForDisplay(isoDate) {
    return isoDate ? moment(makeJSDateObject(isoDate)).format(DATE_LONG_FORMAT) : "";
}

export function formatHoraForDisplay(isoTime) {
    return isoTime ? moment(makeJSDateObject(isoTime), 'HH:mm:ss').format(TIME_SHORT_FORMAT) : "";
}

export function formatHoraAMPMForDisplay(isoTime) {
    return isoTime ? moment(makeJSDateObject(isoTime), 'HH:mm:ss').format(TIME_SHORT_FORMAT_AM_PM) : "";
}

// FUNCIONES PARA FORMATEAR VALORES ESPECIFICOS

export function formatToNA(value) {
    return (isString(value) && value === '') || isNull(value) || isUndefined(value) ? 'N/A' : value;
}

export function formatToGrupoSanguineo(value) {
    const gs = GRUPOS_SANGUINEOS.find(g => g.value === value);
    return formatToNA(gs ? gs.text : null);
}

export function formatToBR(text, separator) {
    if (!text) {
        return text;
    }
    let parrafos = text.split(separator || "\\n");
    return <React.Fragment>
        {parrafos.map((parrafo, index) => {
            return (
                <React.Fragment key={index}>
                    {parrafo}
                    < br />
                </React.Fragment>
            )
        })}
    </React.Fragment>
}

export function formatColonia(colonia) {
    var coloniaStr = '';
    const comma = ', ';

    coloniaStr += colonia.nombreAsentamiento;
    coloniaStr += "\\n";

    coloniaStr += colonia.nombreMunicipio;

    if (!isEmpty(colonia.nombreCiudad)) {
        coloniaStr += comma;
        coloniaStr += colonia.nombreCiudad;
    }

    coloniaStr += "\\n";
    coloniaStr += colonia.nombreEntidad;
    return coloniaStr;
}

export function formatDomicilio(domicilio) {
    var domicilioStr = '';
    var comma = '';

    if (!isEmpty(domicilio.calle)) {
        domicilioStr += domicilio.calle.trim();
    }
    if (!isEmpty(domicilio.numeroExterior)) {
        domicilioStr += " ";
        domicilioStr += domicilio.numeroExterior.trim();
    }
    if (!isEmpty(domicilio.numeroInterior)) {
        domicilioStr += " ";
        domicilioStr += domicilio.numeroInterior.trim();
    }

    if (!isEmpty(domicilio.colonia) || !isEmpty(domicilio.municipio)) {
        domicilioStr += "\\n";
    }
    if (!isEmpty(domicilio.colonia)) {
        domicilioStr += domicilio.colonia.trim();
        comma = ", ";
    }

    if (!isEmpty(domicilio.municipio)) {
        domicilioStr += comma;
        domicilioStr += domicilio.municipio.trim();
    }

    if (!isEmpty(domicilio.cp) || !isEmpty(domicilio.estado)) {
        domicilioStr += "\\n";
    }
    comma = "";

    if (!isEmpty(domicilio.cp)) {
        domicilioStr += domicilio.cp.trim();
        comma = ", ";
    }

    if (!isEmpty(domicilio.estado)) {
        domicilioStr += comma;
        domicilioStr += domicilio.estado.trim();
    }

    return domicilioStr;
}

export function stringAvatar(name) {
    return {
        //   sx: {
        //     bgcolor: stringToColor(name),
        //   },
        children: name.split(' ').length > 2 ? `${name.split(' ')[0][0]}${name.split(' ')[1][0]}` : `${name.split(' ')[0][0]}`,
    };
}